import styled, { css } from 'styled-components';
import { GridItemStyledProps, GridStyledProps } from './Grid.type';
import { forEachBreakpoint, SpacingValue } from 'styled-system';

const getValuePx = (value: string) => Number(value.replace('px', ''));
const getGridMargin = (props: GridStyledProps) => {
  let styles = '';
  forEachBreakpoint((breakpoint) => {
    const marginX = props.rowSpacing[breakpoint] as SpacingValue;
    const marginY = props.columnSpacing[breakpoint] as SpacingValue;
    styles += `
        @media only screen and (min-width: ${
          props.theme.breakpoints[breakpoint]
        }px) {
          margin: ${getValuePx(props.theme.spacing[marginX]) / -2}px
          ${getValuePx(props.theme.spacing[marginY]) / -2}px;
        }
      `;
  });
  return css`
    ${styles}
  `;
};

const getGridItemPadding = (props: GridStyledProps) => {
  let styles = '';
  forEachBreakpoint((breakpoint) => {
    const paddingX = props.rowSpacing[breakpoint] as SpacingValue;
    const paddingY = props.columnSpacing[breakpoint] as SpacingValue;
    styles += `
        @media only screen and (min-width: ${
          props.theme.breakpoints[breakpoint]
        }px) {
          padding: ${getValuePx(props.theme.spacing[paddingX]) / 2}px
          ${getValuePx(props.theme.spacing[paddingY]) / 2}px;
        }
      `;
  });
  return css`
    ${styles}
  `;
};

const getGridItemWidth = (props: GridItemStyledProps) => {
  let styles = '';

  forEachBreakpoint((breakpoint) => {
    if (props[breakpoint] === 'auto') {
      styles += `
        @media only screen and (min-width: ${props.theme.breakpoints[breakpoint]}px) {
          width: auto;
          flex: 1 1 0;
        }
      `;
    } else if (props[breakpoint] === 'shrink') {
      styles += `
        @media only screen and (min-width: ${props.theme.breakpoints[breakpoint]}px) {
          width: auto;
          flex: 0 1 auto;
        }
      `;
    } else if (props[breakpoint] === 'grow') {
      styles += `
        @media only screen and (min-width: ${props.theme.breakpoints[breakpoint]}px) {
          width: auto;
          flex: 1 0 auto;
        }
      `;
    } else {
      styles += `
        @media only screen and (min-width: ${props.theme.breakpoints[breakpoint]}px) {
    width: calc(100% * ${props[breakpoint]} / ${props.gridColumns});
        }
      `;
    }
  });

  return css`
    ${styles}
  `;
};

const getGridItemOrder = (props: GridItemStyledProps) => {
  const { order } = props;
  let styles = '';
  if (order) {
    forEachBreakpoint((breakpoint) => {
      styles += `
        @media only screen and (min-width: ${props.theme.breakpoints[breakpoint]}px) {
    order: ${order[breakpoint]};
        }`;
    });
  }
  return css`
    ${styles}
  `;
};

const GridItem = styled.div<GridItemStyledProps>`
  margin: 0;
  box-sizing: border-box;
  ${getGridItemWidth}
  ${getGridItemOrder}
`;

const Grid = styled.div<GridStyledProps>`
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-flow: ${(props) => (props.direction ? props.direction : 'row')} wrap;
  flex-wrap: ${(props) => (props?.wrap ? props?.wrap : 'wrap')};
  ${({ alignItems }) =>
    alignItems &&
    `
    align-items: ${alignItems};
  `}

  ${({ direction }) =>
    direction &&
    `
    directions: ${direction};
  `}

  ${({ justifyContent }) =>
    justifyContent &&
    `
    justify-content: ${justifyContent};
  `}

  ${getGridMargin};

  > ${GridItem} {
    ${getGridItemPadding}
  }
`;

export { Grid, GridItem };
